import React, { useState } from 'react';

const Logo = ({ size = "medium", showText = true }) => {
  const [imageError, setImageError] = useState(false);
  
  const logoStyle = {
    height: size === "large" ? "60px" : size === "small" ? "30px" : "40px",
    width: "auto"
  };

  const textStyle = {
    color: "var(--primary-coral)",
    fontWeight: "700",
    fontSize: size === "large" ? "28px" : size === "small" ? "16px" : "24px",
    marginLeft: "12px"
  };

  const fallbackStyle = {
    width: logoStyle.height,
    height: logoStyle.height,
    backgroundColor: "var(--primary-coral)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontWeight: "bold",
    fontSize: size === "large" ? "24px" : size === "small" ? "12px" : "16px"
  };

  const handleImageError = (e) => {
    console.error('Logo image failed to load:', e.target.src);
    setImageError(true);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {!imageError ? (
        <img 
          src={`${process.env.PUBLIC_URL}/ph_logo23.png`}
          alt="Pflegehelden Logo" 
          style={logoStyle}
          onError={handleImageError}
          onLoad={() => console.log('Logo loaded successfully')}
        />
      ) : (
        <div style={fallbackStyle}>
          PH
        </div>
      )}
      {/* {showText && (
        <span style={textStyle}>
          Pflegehelden
        </span>
      )} */}
    </div>
  );
};

export default Logo; 